const getters = {
  settingGroups: (state) => state.setting_groups,
  groupSettings: (state) => state.group_settings,
  groupSetting: (state) => state.group_setting,
  customSettingValues: (state) => state.custom_setting_values,
  generalSettings: (state) => state.general_settings,
  baseUrl: (state) => state.base_url,
  getDefaultDateFormat: (state) => {
    return state.general_settings?.find((setting) => setting.code === "FRE_GENERAL_DATE_FORMAT")?.value ?? "YYYY-MM-DD";
  },
  getDxGridDefaultDateFormat: (state) => {
    let format = state.general_settings?.find((setting) => setting.code === "FRE_GENERAL_DATE_FORMAT")?.value ?? "YYYY-MM-DD";
    return format.replace(/D/g, "d").replace(/Y/g, "y");
  },
  getQuantityDecimalPlaces: (state) => {
    const val = state.general_settings?.find((setting) => setting.code === "STOCK_QUANTITY_DECIMALS")?.value;
    const parsed = parseInt(val);
    return isNaN(parsed) ? 4 : parsed;
  },
  getDxGridDefaultNumberFormat: (state) => {
    const val = state.general_settings?.find((setting) => setting.code === "STOCK_QUANTITY_DECIMALS")?.value;
    const parsed = parseInt(val);
    const decimalPlaces = isNaN(parsed) ? 4 : parsed;
    return `#,##0.${"#".repeat(decimalPlaces)}`;
  },
  getLanguage: (state) => {
    const locale = state.general_settings?.find((setting) => setting.code === "LANG")?.value ?? "en";
    return locale.toLowerCase() === "en" ? "en-US" : locale.toLowerCase() + "-" + locale.toUpperCase();
  },
};

export default getters;
